import React from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import Pagination from '../components/Pagination'
import DateRangeSelect from '../components/DateRangeSelect'

class Invoices extends React.Component {
    constructor (props) {
        super(props)

        const fromDate = new Date()
        fromDate.setMonth(fromDate.getMonth() - 1)

        this.state = {
            isLoaded: false,
            hasError: false,
            invoices: [],
            fromDate: fromDate,
            toDate: new Date(),

            pagination: {
                current_page: 1,
                total_pages: 1
            }
        }
    }

    componentDidMount () {
        this.getData()
    }

    getData (page = 1, fromDate = null, toDate = null) {
        this.scrollToTop()
        this.setState({ invoices: [], isLoaded: false })

        let url = `/api/getInvoices/${page}`
        if (fromDate && toDate) {
            url += `/${fromDate}/${toDate}`
        }

        DataSource.getData(url, result => {
            if (!result.invoices) {
                result.invoices = []
            }

            this.setState({
                invoices: result.invoices,
                pagination: result.meta.pagination,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleChangePage (event) {
        event.preventDefault()
        const page = event.target.dataset.page
        this.setState({ isLoaded: false })
        this.getData(page)
    }

    handleDateRangeSubmit (event) {
	    event.preventDefault()
	    this.getData(1, this.state.fromDate, this.state.toDate)
    }

    scrollToTop () {
        window.scrollTo(this.container.offsetLeft, this.container.offsetTop - 60)
    }

    render () {
	    const headings = ['Invoice date', 'Due date', 'Invoice no.', 'Amount', 'View PDF']

        return (
            <div className='invoices module' ref={el => this.container = el}>
                <Heading title='View invoices' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    {this.state.isLoaded
                        ? <React.Fragment>
                            <h2 className='text-center'>Invoice history</h2>
                            <div className='mb-5'>
                                <DateRangeSelect
                                    fromDate={this.state.fromDate}
                                    toDate={this.state.toDate}
                                    handleSubmit={this.handleDateRangeSubmit.bind(this)}
                                    setDynamicValues={data => this.setState(data)}
                                />
                            </div>
                            {this.state.invoices.length > 0
                                ? <React.Fragment>
                                    <ResponsiveTable data={{ headings: headings, rows: this.state.invoices }} minWidthMobile={600} />
                                    <Pagination page={this.state.pagination.current_page} pageCount={this.state.pagination.total_pages} handleClick={this.handleChangePage.bind(this)} />
                                  </React.Fragment>
                                : <p className='text-center'>You currently have no invoices to view.</p>}
                          </React.Fragment>
                        : ''}
                </ModuleWithLoader>
            </div>
        )
    }
}

export default Invoices



// WEBPACK FOOTER //
// ./resources/js/modules/Invoices.js